import { create } from 'zustand';

interface PopperStore {
  openPopperId: string | null;
  setOpenPopperId: (id: string | null) => void;
}

export const usePopperStore = create<PopperStore>((set) => {
  return {
    openPopperId: null,
    setOpenPopperId: (id) => set({ openPopperId: id }),
  };
});
